import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MinusButtonIcon } from "../../../assets/icons/MinusButtonIcon";
import { PlusButtonIcon } from "../../../assets/icons/PlusButtonIcon";
import styles from "./Counter.module.scss";
export const Counter = (props) => {
    const { value, totalCount, allPlayers, item, handlePlus, handleMinus } = props;
    return (_jsxs("div", Object.assign({ className: styles.counter }, { children: [_jsx("button", Object.assign({ onClick: () => handleMinus(item), disabled: item.count <= item.minCount, style: { opacity: item.count <= item.minCount ? 0.5 : 1 } }, { children: _jsx(MinusButtonIcon, {}) })), _jsx("span", { children: value }), _jsx("button", Object.assign({ onClick: () => handlePlus(item), disabled: !(totalCount < allPlayers.length) ||
                    (item.maxCount ? item.maxCount <= item.count : false), style: {
                    opacity: !(totalCount < allPlayers.length) ||
                        (item.maxCount ? item.maxCount <= item.count : false)
                        ? 0.5
                        : 1,
                } }, { children: _jsx(PlusButtonIcon, {}) }))] })));
};
